import { z } from 'zod'

export const createInviteSchema = z.object({
  email: z.email('Email inválido'),
  roleId: z.string().min(1, 'Selecione uma função'),
})

export const acceptInviteSchema = z.object({
  name: z.string().min(2, 'Nome obrigatório'),
  password: z.string().min(8, 'Senha deve ter no mínimo 8 caracteres'),
})

export type CreateInviteFormData = z.infer<typeof createInviteSchema>
export type AcceptInviteFormData = z.infer<typeof acceptInviteSchema>
